import { render } from "./EditAccount.vue?vue&type=template&id=369e8da2&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"

import "./EditAccount.vue?vue&type=style&index=0&id=369e8da2&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369e8da2"]])

export default __exports__